export function uniqueMemberCount(
  grants: readonly {
    user?: { id: string; deactivated?: boolean | null } | null;
  }[]
): number {
  const ids = new Set<string>();
  for (const g of grants) {
    if (!g.user || g.user.deactivated) continue;
    ids.add(g.user.id);
  }
  return ids.size;
}

export function memberCountLabel(count: number): string {
  const suffix = count === 1 ? "member" : "members";
  return `${count} ${suffix}`;
}

export type MemberGroupMap = Map<string, string[]>;

type GroupWithGrants = {
  name: string;
  roleGrantsAsScope: readonly { userId: string | null }[];
};

export function buildMemberGroupMap(
  groups: readonly GroupWithGrants[]
): MemberGroupMap {
  const map = new Map<string, string[]>();
  for (const group of groups) {
    for (const grant of group.roleGrantsAsScope) {
      if (!grant.userId) continue;
      let names = map.get(grant.userId);
      if (!names) {
        names = [];
        map.set(grant.userId, names);
      }
      if (!names.includes(group.name)) names.push(group.name);
    }
  }
  for (const names of map.values()) names.sort((a, b) => a.localeCompare(b));
  return map;
}

export function userGroupNamesForMember(
  memberId: string,
  memberGroupMap: MemberGroupMap
): string[] {
  return memberGroupMap.get(memberId) ?? [];
}
